import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import classes from './SiteNavBMobileLevelC.module.scss';

const SiteNavBMobileLevelC = (props) => {
  const {
    isVisible,
    heading,
    href,
    target,
    items = [],
    onMenuItemClick,
  } = props;

  const renderButtons = (item, itemIndex) => {
    const {
      isVisible: treeItemIsVisible,
      heading: treeItemHeading,
      href: treeItemHref,
      target: treeItemTarget,
      items: treeItemItems = [],
    } = item;

    return (
      treeItemIsVisible &&
        <div className={classes.treeItemContainer} key={`link-${itemIndex}`}>
          {treeItemItems.length > 0 ? (
            <button
              aria-label={`${treeItemHeading}-menu-button`}
              type='button'
              onClick={() => onMenuItemClick(item)}
            >
              <div
                dangerouslySetInnerHTML={{ __html: treeItemHeading }}
              />
            </button>
          ) : (
            <Link
              href={treeItemHref}
              target={treeItemTarget}
              key={treeItemHref}
            >
              <div
                dangerouslySetInnerHTML={{ __html: treeItemHeading }}
              />
            </Link>
          )}
        </div>
    );
  };

  return (
    isVisible ? (
      <div className={classes.container}>
        {href &&
          <Link
            href={href}
            target={target}
            key={href}
            className={classes.menuHeadingLink}
          >
            <div
              className={classes.menuHeadingTitle}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <FontIcon icon='far fa-chevron-right' className={classes.menuIcon} />
          </Link>}
        {items.map((item, itemIndex) => renderButtons(item, itemIndex))}
      </div>) : null
  );
};

const TItem = PropTypes.shape({
  isVisible: PropTypes.bool,
  heading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  items: PropTypes.array,
});

SiteNavBMobileLevelC.propTypes = {
  isVisible: PropTypes.bool,
  href: PropTypes.string,
  heading: PropTypes.string,
  target: PropTypes.string,
  items: PropTypes.arrayOf(TItem),
  onMenuItemClick: PropTypes.func,
};

export default SiteNavBMobileLevelC;
